<template>
  <div class="login-wrapper">

    <Head :title="$tc('header.back')"
          :lanshow="ActiveName" />
    <!-- <NavBar /> -->

    <div style="position: relative">
      <AccountLogin class="login-box"
                    v-if="isshowAccountLogin"
                    @toMobileVerificationCodeLogin="changeLogin"
                    @toPasswordRetrieval="changeLogin" />
      <MobileVerificationCodeLogin class="login-box"
                                   v-if="isMobileVerificationCodeLogin"
                                   @toAccountLogin="changeLogin" />
      <PasswordRetrieval class="login-box"
                         v-if="isPasswordRetrieval"
                         @toMobileVerificationCodeLogin="changeLogin"
                         @goBackAccountLogin="changeLogin" />
    </div>
    <Footer class="footer" />
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import AccountLogin from '@/components/LoginRegistrationForm/AccountLogin.vue'
import MobileVerificationCodeLogin from '@/components/LoginRegistrationForm/MobileVerificationCodeLogin.vue'
import PasswordRetrieval from '@/components/LoginRegistrationForm/PasswordRetrieval.vue'
import Footer from '@/components/Footer.vue'

export default {
  data () {
    return {
      isshowAccountLogin: true,
      isMobileVerificationCodeLogin: false,
      isPasswordRetrieval: false
    }
  },
  computed: {
    ...mapState(['ActiveName'])
  },
  created () {
    // 用户是否登录
    const token =
      localStorage.getItem('userInfo') &&
      JSON.parse(localStorage.getItem('userInfo')) &&
      JSON.parse(localStorage.getItem('userInfo')).token
    if (token) {
      // 显示登陆头像
      this.setActiveName(true)
    } else {
      this.setActiveName(false)
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.$Common.pageShare()
    })
    this.setShowLoading(false)
  },
  methods: {
    ...mapMutations(['setShowLoading', 'setActiveName']),
    changeLogin (e) {
      if (e == 'MobileVerificationCodeLogin') {
        this.isshowAccountLogin = false
        this.isMobileVerificationCodeLogin = true
        this.isPasswordRetrieval = false
      } else if (e == 'AccountLogin') {
        this.isshowAccountLogin = true
        this.isMobileVerificationCodeLogin = false
        this.isPasswordRetrieval = false
      } else if (e == 'PasswordRetrieval') {
        this.isshowAccountLogin = false
        this.isMobileVerificationCodeLogin = false
        this.isPasswordRetrieval = true
      }
    }
  },
  components: {
    AccountLogin,
    MobileVerificationCodeLogin,
    PasswordRetrieval,
    Footer
  },
  watch: {}
}
</script>

<style lang="scss">
.login-wrapper {
  background: url("../assets/img/login-bg.png") no-repeat center top;
  background-size: 100% 100%;
  min-height: 100%;
  //padding: 0 3.981vw 5.833vw;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: center;

  .login-box {
    padding-top: 20vw;
    width: 92vw;
  }
  .footer {
    margin-top: 10vw;
    height: 45.6vw;
  }
}
</style>
